module.exports = __webpack_public_path__ + "img/render.459c22ed.png";